export default __webpack_public_path__ + "static/media/p3_.314a216c.png";